export * from '@ohmsd/utils';
import ReactiveFetch from './ReactiveFetch';
export  { ReactiveFetch };
import Route from '@ohmsd/utils/Route';
export  { Route };

export function ToggleRouteQueryProp (key) {
  return function _ToggleRouteQueryProp (value) {
    const query = { ...this.$route.query };
    if (value)
      query[key] = value;
    else
      delete query[key];

    return this.$router.push({
      ...this.$route,
      query,
    });
  };
}

import { escapeRegExp } from '@ohmsd/utils';
export function searchFilter (
  list,
  search,
  { field = 'name', minLength = 2 } = {},
) {
  if (!search || search?.length < minLength) return list;
  const searchByField = search.match(/([\w]{2,})\:(.{2,})/);
  if (searchByField) {
    const [, _field, _search] = searchByField;
    if (_field === 'id')
      return list.filter(obj => obj.id == _search);
    field = _field;
    search = _search;
  }
  const re = new RegExp(escapeRegExp(search), 'i');
  return list.filter(obj => re.test(obj[field]));
}

export function parseDateStr (dateStr, delimiter = '/', reverse): Date { // dd/mm/yyyy
  if (Number.isFinite(dateStr))
    return dateStr;
  if (typeof dateStr === 'string') {
    if (!reverse) {
      const [day, month, year] = dateStr.split(delimiter);
      return new Date(Number(year), Number(month) - 1, Number(day));
    } else {
      const [year, month, day] = dateStr.split(delimiter);
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  }
  // throw new Error(`parseDateStr(): cant parse dateStr - ${ dateStr }`);
  return null;
}
